"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconVolumeMute = void 0;
var React = __importStar(require("react"));
var IconVolumeMute = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M21.793,13.79 C22.069,14.065 22.069,14.516 21.793,14.791 C21.652,14.93 21.475,15 21.291,15 C21.107,15 20.927,14.93 20.789,14.791 L19,13.001 L17.211,14.791 C17.069,14.93 16.893,15 16.709,15 C16.525,15 16.345,14.93 16.207,14.791 C15.931,14.516 15.931,14.065 16.207,13.79 L17.996,11.999 L16.207,10.209 C15.931,9.933 15.931,9.483 16.207,9.207 C16.482,8.931 16.932,8.931 17.208,9.207 L18.997,10.998 L20.786,9.207 C21.062,8.931 21.51,8.931 21.786,9.207 C22.062,9.483 22.062,9.933 21.786,10.209 L19.997,11.999 L21.793,13.79 Z M12.3511,4.084 C12.5981,3.891 13.0041,4.057 13.0001,4.327 L13.0001,11.976 L13.0001,12.057 L13.0001,19.705 C13.0001,19.976 12.5941,20.1 12.3471,19.906 L6.0001,15 L3.0001,15 C2.4481,15 2.0001,14.553 2.0001,14 L2.0001,10 C2.0001,9.447 2.4481,9 3.0001,9 L6.0001,9 L12.3511,4.084 Z" }))); };
exports.IconVolumeMute = IconVolumeMute;
exports.IconVolumeMute.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconVolumeMute;
